var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":this.$store.state.spin.isLoading,"color":"#5867dd"},on:{"update:active":function($event){return _vm.$set(this.$store.state.spin, "isLoading", $event)}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }